
import { onMounted, defineComponent } from "vue";
import { getFileUrl, getParameter } from "@/api/index";
export default defineComponent({
  setup() {
    const getFileUrls = () => {
      getFileUrl().then((res: any) => {
        if (res.code === 200) {
          localStorage.setItem("fileUrel", res.data.value);
        }
      });
    };
    onMounted(() => {
      getFileUrls();
    });
    return {
      getFileUrl,
    };
  },
  components: {
    // layout,
  },
});
